<template>
    <div class="app-careers">
        <top-hero :heroImage="heroImage" :heroTitle="title"></top-hero>

        <div class="my-5">
            <div class="container mt-5">
                <div class="row mt-5">
                    <div class="col-md-12">
                        <div class="text-center mb-5">
                            <p class="primary-color">WHY JOIN US</p>
                            <h1 class="primary-color header-text">About Working Here</h1>
                        </div>
                    </div>

                    <div class="col-md-4 work-benefit">
                        <ul>
                            <li><h2 class="primary-color header-text">Client Focus</h2></li>
                        </ul>
                        <p>Everything we do is measured against how it moves our clients forward.</p>
                    </div>

                    <div class="col-md-4 work-benefit">
                        <ul>
                            <li><h2 class="primary-color header-text">Smooth Transition</h2></li>
                        </ul>
                        <p>At M&O Law Consult, you’ll get the knowledge and skills you need to succeed.</p>
                    </div>

                    <div class="col-md-4 work-benefit">
                        <ul>
                            <li><h2 class="primary-color header-text">Justice For All</h2></li>
                        </ul>
                        <p>We use our talents to build a better world.</p>
                    </div>

                    

                </div>
            </div>

            <div 
                class="my-5 careers-parallax py-5" 
                :style="{ backgroundImage: 'linear-gradient(rgba(0, 65, 107, 0.68), rgba(0, 65, 107, 0.68)), url('+ workPara +')' }"
                v-if="careers.length > 0"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 my-4">
                            <div class="text-center mb-5">
                                <p class="text-white">VACANCIES LEFT FOR YOU</p>
                                <h2 class="text-white header-text text-capitalize">Available Positions</h2>
                            </div>
                        </div>

                        <div class="col-md-4" v-for="(career, i) in careers" :key="i">
                            <div class="position-card">
                                <div class="card border-0">
                                    <div class="card-body">
                                        <h2 class="header-text-regular primary-color">{{ career.title }}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="container my-5">
                <div class="text-center">
                    <h2 class="display-3 primary-color header-text">Join Us Now</h2>
                </div>
                <div class="row">
                    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <p class="text-center">Delivering excellent client service depends on hiring professionals at the top of their game.</p>
                    </div>

                    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3 mt-5 pt-3">
                        <div class="careerFormMsg"></div>

                        <form class="material-form">
                            <div class="form-group">
                                <input type="text" name="name" id="name" class="form-control"
                                    placeholder="Name" v-model="formData.name" v-validate="'required'"
                                >
                                <span class="d-block text-danger">{{ errors.first('name') }}</span>
                            </div>

                            <div class="form-group">
                                <input type="email" name="email" id="email" class="form-control"
                                    placeholder="Email" v-model="formData.email" v-validate="'required|email'"
                                >
                                <span class="d-block text-danger">{{ errors.first('email') }}</span>
                            </div>

                            <div class="form-group">
                                <input type="text" name="phone" id="phone" class="form-control"
                                    placeholder="Phone" v-model="formData.phone" v-validate="{ required: true, numeric: true, min: 10 }"
                                >
                                <span class="d-block text-danger">{{ errors.first('phone') }}</span>
                            </div>

                            <div class="form-group">
                                <label class="d-block">Upload CV <span class="text-secondary d-block">(pdf, docx, doc, ppt or pptx only)</span></label>
                                <input type="file" name="cv" id="cv" v-validate="'required'" @change="validateFile($event)">
                                <span class="d-block text-danger">{{ errors.first('cv') }}</span>
                                <span class="d-block text-danger" v-if="fileError">{{ fileErrorMsg }}</span>
                            </div>

                            <div class="form-group">
                                <div class="text-center">
                                    <button class="btn btn-primary px-5" @click.prevent="submitApplication($event)">
                                        SUBMIT
                                    </button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
let heroImage = require("@/assets/img/hero/work.jpg");
let workPara = require("@/assets/img/work2.jpg");

import TopHero from "@/components/frontend/Hero.vue";
import axios from "axios";
export default {
    components: {
        TopHero: TopHero
    },
    name: "Careers",
    data() {
        return {
            title: "Work With Us",
            heroImage: heroImage,
            workPara: workPara,
            careers: [],
            formData: {
                name: "",
                email: "",
                phone: ""
            },
            fileError: false,
            fileErrorMsg: ""
        };
    },
    metaInfo() {
        return {
            title: this.title
        };
    },
    methods: {
        fetchCareers() {
            axios
                .get(APIURL + "careers")
                .then(response => {
                    let res = response.data;
                    this.careers = res;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        validateFile(e) {
            let input = e.currentTarget;
            let file = input.files[0];
            let t = file.type
                .split("/")
                .pop()
                .toLowerCase();

            console.log(t);

            if (
                t != "pdf" &&
                t != "doc" &&
                t != "docx" &&
                t != "ppt" &&
                t != "pptx" &&
                t != "vnd.ms-powerpoint"
            ) {
                this.fileError = true;
                this.fileErrorMsg =
                    "File must be of type pdf, doc, docx, ppt or pptx";
                return false;
            }

            if (file.size > 625000) {
                this.fileError = true;
                this.fileErrorMsg = "File size must be less than 5MB";
                return false;
            }

            this.fileError = false;
            this.fileErrorMsg = "";
        },
        submitApplication(e) {
            $(".s-v-e").remove();
            let btn = e.currentTarget;

            this.$validator.validateAll().then(result => {
                if (result) {
                    let self = this;
                    let input = document.querySelector("#cv");
                    let file = input.files[0];
                    let t = file.type
                        .split("/")
                        .pop()
                        .toLowerCase();

                    if (
                        t != "pdf" &&
                        t != "doc" &&
                        t != "docx" &&
                        t != "ppt" &&
                        t != "pptx" &&
                        t != "vnd.ms-powerpoint"
                    ) {
                        this.fileError = true;
                        this.fileErrorMsg =
                            "File must be of type pdf, doc, docx, ppt or pptx";
                        return false;
                    }

                    if (file.size > 625000) {
                        this.fileError = true;
                        this.fileErrorMsg = "File size must be less than 5MB";
                        return false;
                    }

                    btn.classList.add("is-loading", "is-loading-sm");
                    btn.setAttribute("disabled", "");

                    let postData = new FormData();
                    postData.append("name", this.formData.name.trim());
                    postData.append("email", this.formData.email.trim());
                    postData.append("phone", this.formData.phone.trim());
                    postData.append("cv", file, file.name);

                    $.ajax({
                        type: "POST",
                        url: APIURL + "career/apply",
                        data: postData,
                        dataType: "JSON",
                        cache: false,
                        processData: false,
                        contentType: false,
                        success(response) {
                            $(btn)
                                .removeClass("is-loading is-loading-sm")
                                .removeAttr("disabled");
                            if (response.status == 200) {
                            } else {
                                if (response.status == 403) {
                                    $.each(response.errors, (k, v) => {
                                        $("#" + k).after(v);
                                    });
                                } else {
                                }
                            }
                        }
                    });
                }
            });
        }
    },
    created() {
        this.fetchCareers();
    }
};
</script>



// WEBPACK FOOTER //
// src/views/frontend/Careers.vue